// Content
export const HomePageStrings = {
  WELCOME_TXT: '<Hello World! />',
  HOME_INTRO_1: 'Come join us in Frisco, TX, and be part of the global coding movement!',
  HOME_INTRO_2: 'We at Frisco Coder Dojo are excited to have the ninjas and their parents join us',
  HOME_INTRO_3: 'as we explore the wonderful world of coding and computers.',
  ITS_FREE: 'IT\'S FREE!',
  ITS_FREE_1: 'Kids learn how to code, build websites, apps, or games and explore technology in a laid-back, creative, fun and social environment.',
  REGISTER_NOW: 'Register Now!',
  WIN_BADGES: 'Attend the next dojo to earn exciting badges!',
  VIEW_BADGES: 'View all badges',
  FIND_NINJAS: 'Find out how our ninjas are doing.',
  VIEW_NINJAS: 'find ninjas ',
};

export const AppBarStrings = {
  HOME: 'HOME',
  BADGES: 'BADGES',
  CODERS: 'NINJAS',
};

export const ProfileStrings = {
  ACTIVITY: 'Activity Log',
  ACHIEVEMENTS: 'Achievements',
};

export const BadgeStrings = {
  noBadges: 'Attend the next dojo to earn your first badge!',
};

export default {
  AppBarStrings,
  BadgeStrings,
  HomePageStrings,
  ProfileStrings,
};



/** WEBPACK FOOTER **
 ** ./src/common/strings.js
 **/